module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 17.414L8.575 24.84a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707L14.586 16 7.16 8.575a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0L16 14.586l7.425-7.425a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707L17.414 16l7.425 7.425a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/basic/asda-close.svg
// module id = 618
// module chunks = 0